<div class="wrapper">
  <app-sidebar></app-sidebar>
  <div class="main-panel">
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>
<!--<app-fixed-plugin></app-fixed-plugin>-->
